import { RoutingActions } from '@state/slices/app';
import { handlePathChange } from './commonSearchSlice';
import { createListener } from '@state/store/createListener';

// Setup function to initialize all common search listeners
export const setupCommonSearchListeners = () => {
  createListener([RoutingActions.INITIALIZE_PATH], async (_action, listenerApi) => {
    listenerApi.dispatch(handlePathChange());
  });
};
